export const OUTBOUND_FETCH_TIMEOUT_MS = 8_000;
export const OUTBOUND_FETCH_RETRIES = 1;
export const OUTBOUND_FETCH_RETRY_DELAY_MS = 150;

export const UNIFORM_STALE_CACHE_TTL_MS = 3_600_000; // 1 hour

export const UNIFORM_CIRCUIT_FAILURE_THRESHOLD = 5;
export const UNIFORM_CIRCUIT_WINDOW_MS = 10_000;
export const UNIFORM_CIRCUIT_OPEN_MS = 30_000;
export const UNIFORM_CIRCUIT_RETRY_AFTER_SECONDS = 30;
